const ID_TOKEN_KEY = (process.env.VUE_APP_BASE_URL + ':id_token') as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  return localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
